import React from 'react';
import { Filter, TextInput } from 'react-admin';

export default function ReportFilter (props) {
    return (
        <Filter {...props}>
            <TextInput label="Search" source="q" alwaysOn/>
            <TextInput label="Date In" source="date_in" type="date" allowEmpty/>
            <TextInput label="Date To" source="date_to" type="date" allowEmpty/>
        </Filter>
    );
}
